import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: 20px;\n  z-index: 3;\n  position: relative;\n'], ['\n  margin-bottom: 20px;\n  z-index: 3;\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n  @media (max-width: ', ') {\n    flex-direction: column;\n    > div {\n      margin: 10px 0;\n      &:first-of-type {\n        margin-top: 0;\n      }\n    }\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n  @media (max-width: ', ') {\n    flex-direction: column;\n    > div {\n      margin: 10px 0;\n      &:first-of-type {\n        margin-top: 0;\n      }\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  min-width: 300px;\n  @media (max-width: ', ') {\n    margin-bottom: 10px 0 0;\n    min-width: auto;\n  }\n'], ['\n  position: relative;\n  min-width: 300px;\n  @media (max-width: ', ') {\n    margin-bottom: 10px 0 0;\n    min-width: auto;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  @media (max-width: ', ') {\n    font-size: 24px;\n  }\n\n  span {\n    color: ', ';\n  }\n'], ['\n  @media (max-width: ', ') {\n    font-size: 24px;\n  }\n\n  span {\n    color: ', ';\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  font-size: 20px;\n  justify-content: space-between;\n  @media (max-width: ', ') {\n    font-size: 18px;\n  }\n\n  p {\n    margin: 0;\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  font-size: 20px;\n  justify-content: space-between;\n  @media (max-width: ', ') {\n    font-size: 18px;\n  }\n\n  p {\n    margin: 0;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  p {\n    display: inline-block;\n    margin: 0 0 0 5px;\n    font-size: 24px;\n    font-weight: 600;\n    @media (max-width: ', ') {\n      font-size: 18px;\n    }\n  }\n'], ['\n  p {\n    display: inline-block;\n    margin: 0 0 0 5px;\n    font-size: 24px;\n    font-weight: 600;\n    @media (max-width: ', ') {\n      font-size: 18px;\n    }\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  text-decoration: line-through;\n  color: ', ';\n'], ['\n  text-decoration: line-through;\n  color: ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 14px;\n  @media (max-width: ', ') {\n    font-size: 12px;\n  }\n'], ['\n  color: ', ';\n  font-size: 14px;\n  @media (max-width: ', ') {\n    font-size: 12px;\n  }\n']);

import styled from 'styled-components';

export var StyledDiv = styled.div(_templateObject);

export var StyledFlexDiv = styled.div(_templateObject2, function (props) {
  return props.theme.tabletWidth;
});

export var StyledRightFlex = styled.div(_templateObject3, function (props) {
  return props.theme.tabletWidth;
});

export var StyledTitle = styled.h4(_templateObject4, function (props) {
  return props.theme.tabletWidth;
}, function (props) {
  return props.theme.dormifyBoulder;
});

export var StyledSubtotal = styled.div(_templateObject5, function (props) {
  return props.theme.tabletWidth;
});

export var StyledSubtotalAmount = styled.div(_templateObject6, function (props) {
  return props.theme.tabletWidth;
});

export var StyledStrikeThrough = styled.p(_templateObject7, function (props) {
  return props.theme.dormifyBoulder;
});

export var StyledInfo = styled.p(_templateObject8, function (props) {
  return props.theme.dormifyBoulder;
}, function (props) {
  return props.theme.tabletWidth;
});